export default {"src":"/_next/static/media/tools-empty.b9c8b06b.svg","height":133,"width":187,"blurWidth":0,"blurHeight":0};